<template>
  <v-app>
    <v-toolbar color="blue darken-3" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
      <v-menu bottom left>
        <v-btn slot="activator" dark icon><v-icon>menu</v-icon></v-btn>
        <v-list>
          <v-list-tile :to="{ name: 'root' }">
            <v-list-tile-title>{{ $language('menu.left.start') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile :to="{ name: 'employees' }">
            <v-list-tile-title>{{ $language('menu.left.employees') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile :to="{ name: 'projects' }">
            <v-list-tile-title>{{ $language('menu.left.projects') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile :to="{ name: 'planning' }">
            <v-list-tile-title>{{ $language('menu.left.planning') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <span class="hidden-sm-and-down">
          {{ title }}
        </span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-toolbar-title class="ml-0 pl-3">
        <span class="hidden-sm-and-down">{{ user.name }}</span>
      </v-toolbar-title>

      <v-menu bottom left>
        <v-btn slot="activator" dark icon><v-icon>person</v-icon></v-btn>
        <v-list>
          <v-list-tile v-if="isAuthenticated" @click="logout">
            <v-list-tile-title>{{ $language('menu.right.logout') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-else :href="oauthUrl">
            <v-list-tile-title>{{ $language('menu.right.login') }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-content>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-content>

    <v-snackbar v-model="$store.state.snackbar.model" v-bind="$store.state.snackbar.props">
      {{ $store.state.snackbar.message }}
      <v-btn dark flat @click="$store.commit('snackbar/hide')">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'app',
  data() {
    return {
      oauthUrl: '',
    };
  },
  computed: {
    ...mapState('auth', ['user', 'isAuthenticated']),
    ...mapState('page', ['title']),
  },
  methods: {
    async logout() {
      try {
        // await this.$api.auth.revoke();
        this.$cookies.remove('token');
        this.$store.commit('auth/logout');
        // this.$router.push({ name: 'root' });
        // const { href } = this.$router.resolve({ name: 'root' });
        // top.location.href = href;
        top.location.reload();
      } catch (err) {
        console.log(err);
        this.$store.commit('snackbar/show', (err.response && err.response.data && err.response.data.message) || err.message);
        throw err;
      }
    },
    async fetchAuthorizeUrl() {
      this.oauthUrl = await this.$api.auth.url();
    },
    async fetchUser() {
      const user = await this.$api.auth.user();
      this.$store.commit('auth/login', { user, token: this.$cookies.get('token') });
    },
  },
  async created() {
    try {
      await this.fetchUser();
      await this.fetchAuthorizeUrl();
    } catch (err) {
      console.log(err);
      this.$store.commit('snackbar/show', (err.response && err.response.data && err.response.data.message) || err.message);
      throw err;
    }
  },
};
</script>

<style lang="scss" scoped>
  /deep/ a {
    color: #333 !important;
    text-decoration: none;
  }

  /deep/ .application--wrap {
    width: 100%;
  }
</style>
